import ComposePass from '../particles/compose';

export default class ArrowComposePass extends ComposePass {}
